import { type AnyObject } from '@Types';
import { type ExecEdCertCategory } from 'ExecEdEligibility';
import { type InstitutionId } from 'Institutions';
import { type ProgramType } from 'Program';

export type Locale<KeyType extends string = string> = { key: KeyType; params?: AnyObject };

export enum SelectProgramSection {
    degree = 'degree',
    execEd = 'exec_ed',
}

type BaseProgramListItem = {
    section: SelectProgramSection;
    image: string;
    imageMode: 'center' | 'cover';
    title: Locale;
    description: Locale;
    preapprovedDescription?: Locale;
    learnMoreUrl: string;
    programType: ProgramType;
    isVisible: (institutionID: InstitutionId) => boolean;
};

export type ProgramListWithSubSectionsItem = BaseProgramListItem & {
    subSection: ExecEdCertCategory;
};

export type ProgramListItem = BaseProgramListItem | ProgramListWithSubSectionsItem;

export type BaseProgramList = {
    section: SelectProgramSection;
    subSection?: ProgramListWithSubSectionsItem['subSection'];
    title: Locale;
    intro?: Locale;
    className?: string;
};

export type ProgramList = BaseProgramList & { items: ProgramListItem[] };
export type ProgramListWithSubSections = BaseProgramList & { subSections: ProgramList[] };

export type SelectProgramConfig = (ProgramList | ProgramListWithSubSections)[];
